import * as Dropzone from "dropzone"
import * as NoUiSlider from "nouislider"

import {App} from "./app";
import {Utility} from "../utility";
import {Analytics} from "../analytics";

export class ImageApp extends App {
    protected supported_types: string[];
    protected max_file_size: number;
    protected file_picker: Dropzone;

    constructor(supported_types: string[], max_file_size: number = 4) {
        super();
        this.supported_types = supported_types;
        this.max_file_size = max_file_size;
    }

    run() {
        super.run();

        this.disableSubmitButton();

        this.initDropzone();
        this.initSlider();

        $("#txt-url").on("change", () => {
            this.onFileUrlChanged($("#txt-url").val().trim());
        });

        $("#btn-remove-image").on("click", () => {
            this.chooseNextFile(true);
        });

        $("#frm-upload-file").on("submit", event => {
            event.preventDefault();
            this.handleForm();
        });

        $("#h2-select").find("a").on("click", event => {
            event.preventDefault();
            this.chooseNextFile();
        });

        $("#btn-select-next-image").on("click", () => {
            $("#result-container").fadeOut("fast");
            this.chooseNextFile();
        });

        this.hidePreloader();
    }

    protected initDropzone() {
        this.file_picker = new Dropzone("#image-dropzone", {
            url: "upload.php",
            method: 'post',
            uploadMultiple: false,
            paramName: "image",
            addRemoveLinks: true,
            createImageThumbnails: true,
            maxFilesize: this.max_file_size,
            maxFiles: 1,
            acceptedFiles: this.supported_types.join(','),
            autoProcessQueue: false,

            success: (file, response) => {
                const filename = response;
                file.previewElement.classList.add("dz-success");
                console.log("Successfully uploaded :" + filename);
            },

            error: file => {
                file.previewElement.classList.add("dz-error");
            }
        });

        this.file_picker.on("addedfile", file => {
            this.onFileAdded(file);
        });

        this.file_picker.on("removedfile", () => {
            this.onFileRemoved();
        });
    }

    protected onFileAdded(file: any) {
        Analytics.event("image", "image_selected");

        $("#selected-orig-image-url").fadeOut("fast");
        $("#image-picker").fadeOut("fast", () => {
            const reader = new FileReader();
            reader.addEventListener("load", () => {
                $("#original_image").prop("src", reader.result);
                $("#selected-orig-image").show("fast");
                $("#selected-orig-image-control").show("fast");

                let dimensions = '';

                //todo width and height properties should not exist on DropzoneFile by specification
                if (file['width']) {
                    dimensions = `, ${file['width']}x${file['height']}`;
                }
                $("#orig_stats").html(`${file.name}${dimensions}, ${Utility.formatSize(file.size)}`);
                this.enableSubmitButton();

                Analytics.event("image", "image_loaded", {
                    name: file.name,
                    width: file.width,
                    height: file.height,
                    size: file.size
                }, file.size);
            }, false);

            reader.readAsDataURL(file);
        });

        if (this.file_picker.files.length > 1) {
            this.file_picker.removeFile(this.file_picker.files[0]);
        }

        this.hideError();
    }

    protected onFileRemoved() {
        Analytics.event("image", "image_removed");
        this.disableSubmitButton();
        this.hideError();
    }

    protected initSlider() {
        const slider = $('#nouislider_basic_example').get(0) as NoUiSlider.Instance;
        NoUiSlider.create(slider, {
            start: [+$("#inp-quality").val()],
            connect: "lower",
            step: 1,
            range: {
                min: [1],
                max: [100]
            }
        });

        slider.noUiSlider.on("update", () => {
            const val = parseInt(slider.noUiSlider.get().toString());
            const lossless = val === 100;

            $("#inp-quality").val(val.toString());

            let val_string = lossless ? "lossless" : `${val}%`;

            $(slider).parent().find('span.js-nouislider-value').text(val_string);
        });
    }

    protected chooseNextFile(reset_selected: boolean = false) {
        $("#h2-select").hide();
        $("#h2-select-readonly").show();
        $("#select-image-body").show('fast');
        this.hideContact();

        if (reset_selected) {
            $("#selected-orig-image").hide("fast");
            $("#selected-orig-image-control").hide("fast");
            $("#image-picker").show("fast");
            $("#selected-orig-image-url").show("fast");
            this.file_picker.removeAllFiles();
            $("#txt-url").val("");
            this.disableSubmitButton();
        }

        window.location.hash = '#nav-top';
    }

    protected onFileUrlChanged(url: string) {
        if (!url) {
            return;
        }

        if (!/^https?:\/\/.+/.test(url) && !/^data:image\/\w+;base64,.+/.test(url)) {
            this.showError('Invalid URL format');
            return;
        }

        const image = new Image();
        image.onload = () => {
            let name: string;
            if (/^data:/.test(url)) {
                const mime = url.substr(5).split(';')[0];
                switch (mime) {
                    case 'image/jpeg':
                        name = "image.jpg";
                        break;
                    case 'image/png':
                        name = 'image.png';
                        break;
                    case 'image/gif':
                        name = 'image.gif';
                        break;

                    default:
                        name = 'image';
                }

            } else {
                const fragments = url.split('?')[0].split('#')[0].split('/');
                name = fragments.pop();
                if (!name) {
                    name = fragments.pop();
                }
            }

            $("#selected-orig-image-url").fadeOut("fast");
            $("#image-picker").fadeOut("fast");
            $("#original_image").prop("src", url);
            $("#selected-orig-image").show("fast");
            $("#selected-orig-image-control").show("fast");
            $("#orig_stats").html(`${name}, ${image.naturalWidth}x${image.naturalHeight}`);
            this.enableSubmitButton();
        };

        image.onerror = () => {
            this.showError("Failed to load image from URL");
        };
        image.src = url;

        if (/^data:/.test(url)) {
            const mime = url.substr(5).split(';')[0];

            Analytics.event("image", "url_changed", `data:${mime}`);
        } else {
            Analytics.event("image", "url_changed", `data:${url}`);
        }
    }

    protected async handleForm() {
        const form_data = new FormData($('#frm-upload-file').get(0) as HTMLFormElement);

        if (this.file_picker.files.length) {
            form_data.append('image', this.file_picker.files[0]);
        }

        Analytics.event("image", "optimize_submit", {
            quality: +form_data.get('quality'),
            strip_headers: !!form_data.get('strip'),
            method: form_data.get('method')
        });

        this.hideError();
        this.hideContact();
        $("#result-container").hide();
        $("#resized_image").prop("src", "");

        await this.showPreloader();
        this.post("upload.php", form_data, response => {
            this.hidePreloader();

            $("#h2-select-readonly").hide();
            $("#h2-select").show();

            let results = `Original size: <strong> ${Utility.formatSize(response['orig_size'])}</strong>, optimized size: <strong>${Utility.formatSize(response['optimized_size'])}</strong>`;
            if (response['optimized_percent'] >= 100) {
                results += " - already well optimized"
            } else {
                const saved_percent = (100 - response['optimized_percent']).toFixed(2);
                results += ` - saved <strong>${Utility.formatSize(response['orig_size'] - response['optimized_size'])}</strong> (<strong>${saved_percent}%</strong>)`;
            }

            $("#optimization-result-stats").html(results);

            const src_data_url = `data:${response["type"]};base64,${response["orig_image"]}`;
            const optimized_data_url = `data:${response["type"]};base64,${response["optimized_image"]}`;

            $("#resized_image").prop("src", optimized_data_url);
            $("#original_image_res").prop("src", src_data_url);
            $("#original_image_name")
                .prop("download", response['name'])
                .prop('href', response["url"] || src_data_url)
                .text(response['name']);
            $("#optimized_image_name")
                .prop("download", response['optimized_name'])
                .prop('href', optimized_data_url)
                .text(response['optimized_name']);

            $("#span-orig-size").html(`${response['width']}x${response['height']}, ${Utility.formatSize(response['orig_size'])}`);
            $("#span-optimized-size").html(`${response['width']}x${response['height']}, ${Utility.formatSize(response['optimized_size'])}`);

            $("#select-image-body").hide("fast");
            $("#result-container").show("fast", () => {
                window.location.hash = "#result-container";
            });

            this.showContact();

            Analytics.event("image", "optimize_success", {
                width: response['width'],
                height: response['height'],
                orig_size: response['orig_size'],
                optimized_size: response['optimized_size'],
                optimized_percent: response['optimized_percent'],
                duration: response['duration']
            }, response['optimized_percent'])
        }, error => {
            this.hidePreloader();
            this.showError(error);
            this.disableSubmitButton();

            Analytics.event("image", "optimize_error", error);
        }, error => {
            this.hidePreloader();
            this.showError(`ERROR - ${error}`);

            Analytics.event("image", "optimize_error", error);
            Analytics.exception(error, true);
        });
    }
}
